/* 合同信息接口 */

import ajax from '../ajax';
import axios from 'axios';
export default {
  // 获取项目合同列表
  getProjectContractList (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/blReadContractList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
   // 获取主合同列表
  getMainContractList (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/blMainContractList.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
  signContract (params) {
    return ajax.postForm('/mobile/item/shortcutSignature/blPdfSignatureCustomer.ht', params);
  },
  signContractForMain (params) {
    return ajax.postForm('/mobile/item/pdfSignatureController/customerSignMainContract.ht', params);
  },
  // 获取合同角色是否可以签署
  getIfCanSign (params) {
    return axios.get(
      'mobile/item/pdfSignatureController/ifCanSign.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  },
  checkNum (search) {
    const params = {
      ...search
    };
    return axios.get(
      '/mobile/item/pdfSignatureController/waiSignInfo.ht',
      {
        headers: {
          tokenId: localStorage.getItem('dl_tokenId_bl')
        },
        params
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/api/personalCenter/projectContract.js